import React, {
    Component,
} from 'react';

import { connect } from 'react-redux';

import { carrierDataSelectors } from 'wanderu-ducks-carriers';
import {
    fetchTripInformationAction,
    fetchTripItineraryAction,
    tripSelectors,
} from 'wanderu-ducks-trips';

import ItineraryComponent from '../components/Itinerary/Itinerary';
import {
    selectItineraries,
} from '../ducks/appstate/selectors';

class Itinerary extends Component {
    componentDidMount() {
        const {
            fetchInfoForId: tripId,
        } = this.props;

        if (tripId) {
            this.props.fetchTripInformation([tripId]);
        }
    }

    /**
     * live details for this trip were requested, either by expanding the show-
     * details dropdown or by expanding the stops list of a trip itinerary
     */
    onGetItineraryInfo = (tripId) => {
        const {
            onDemandTripDetailsLoading,
        } = this.props;

        /* do nothing if we're already doing something */
        if (onDemandTripDetailsLoading) {
            return;
        }

        this.props.fetchTripItinerary(tripId);
    }

    render() {
        return (
            <ItineraryComponent
                {...this.props}
                onGetItineraryInfo={this.onGetItineraryInfo}
            />
        );
    }
}

function mapStateToProps(appState, ownProps) {
    const {
        tripId,
    } = ownProps;
    const { selectCarrierData } = carrierDataSelectors;

    let fetchInfoForId = '';
    const trip = tripSelectors.selectTrip(appState, tripId);
    const carrier = selectCarrierData(appState, [trip.carrierCode]);
    const tripCarrier = carrier[trip.carrierCode];

    if (tripCarrier
        && tripCarrier.supplementalInfo
        && tripCarrier.supplementalInfo.tripinfo) {
        fetchInfoForId = trip.tripId;
    }

    return {
        fetchInfoForId,
        arrival: tripSelectors.selectTripArriveData(appState, tripId),
        carrier,
        departure: tripSelectors.selectTripDepartData(appState, tripId),
        itineraries: selectItineraries(appState, tripId),
        itineraryError: !!fetchTripItineraryAction.selectError(appState, tripId),
        tripInformation: tripSelectors.selectTripInformation(appState, tripId),
    };
}

const mapDispatchToProps = {
    fetchTripInformation: fetchTripInformationAction.fetchTripInformation,
    fetchTripItinerary: fetchTripItineraryAction.fetchTripItinerary,
};

export { Itinerary };
export default connect(mapStateToProps, mapDispatchToProps)(Itinerary);
